import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e740bfd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment-success-view" }
const _hoisted_2 = { class: "payment-success" }
const _hoisted_3 = { class: "payment-success__title" }
const _hoisted_4 = { class: "payment-success__details details" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "details__accompanying-text" }, " Cпасибо, что выбрали нас ", -1))
const _hoisted_6 = { class: "details__total-info" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Сумма заказа:", -1))
const _hoisted_8 = { class: "rouble-symbol" }
const _hoisted_9 = { class: "details__delivery-info delivery-info" }
const _hoisted_10 = { class: "delivery-info__text rouble-symbol" }
const _hoisted_11 = { class: "payment-success__products products" }
const _hoisted_12 = { class: "product-item__details-block" }
const _hoisted_13 = { class: "product-item__title" }
const _hoisted_14 = { class: "product-item__price rouble-symbol" }
const _hoisted_15 = {
  key: 0,
  class: "payment-success__not-confirmed"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Истекло время ожидания подтверждения оплаты", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "После подтверждения оплаты заказ появится в личном кабинете", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Если заказ не появляется, то обратитесь в техническую поддержку ", -1))
const _hoisted_19 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "payment-success__expected-payment"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MoSpinner = _resolveComponent("MoSpinner")!
  const _component_PaymentResultPanel = _resolveComponent("PaymentResultPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PaymentResultPanel, null, {
      default: _withCtx(() => [
        _createElementVNode("article", _hoisted_2, [
          (_ctx.order)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("h1", _hoisted_3, [
                  _createTextVNode(" Заказ "),
                  (_ctx.noNeedPayment(_ctx.order))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" оформлен ")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" оплачен ")
                      ], 64))
                ]),
                _createElementVNode("section", _hoisted_4, [
                  _createVNode(_component_router_link, {
                    to: { name: 'c-orders-in-delivery' },
                    class: "base-btn base-btn--default details__button-to-profile"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Перейти в личный кабинет ")
                    ]),
                    _: 1
                  }),
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.order.totalPrice)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, " Доставка: " + _toDisplayString(_ctx.$filters.formattedNumber(_ctx.order.deliveryPrice)), 1)
                  ])
                ]),
                _createElementVNode("section", _hoisted_11, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.items, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.id,
                        class: "product-item"
                      }, [
                        _createElementVNode("div", {
                          class: "product-item__image-block",
                          style: _normalizeStyle({ backgroundImage: `url(${item.product.image})` })
                        }, null, 4),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, _toDisplayString(item.product.name), 1),
                          _createElementVNode("div", _hoisted_14, _toDisplayString(item.quantity) + " x " + _toDisplayString(_ctx.$filters.formattedNumber(item.price)), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.isOver)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_19))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createTextVNode(" Ожидаем подтверждение оплаты "),
                      _createVNode(_component_MoSpinner)
                    ]))
              ], 64))
        ])
      ]),
      _: 1
    })
  ]))
}